<template>
  <v-form>
    <v-container fluid>
      <v-row>


        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
      </v-row>
      <v-divider  ></v-divider>
      <br>
      <div  class="ml-2">
        <h3 class="text-decoration-underline">{{ $t('global.access') }}</h3>
      </div>

      <v-row  >
        <v-col md="6" v-for="access in this.Accessitems" :key="access.id">

          <v-row align="center" class="pa-0 ml-0">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('administration.access.'+ access.name) }}:</strong>
            </v-col>
            <v-col md="4" class="pa-0 ml-0">
              <v-switch
                v-model="accessArray"
                :value="access['@id']"
                class="pa-0 ml-0"
                dense
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>


    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { mapActions, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'ProfilForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.fetchAll({'pagination' : false});
 },
  data() {
    return {
        name: null,
        accessValue: [],
    };
  },
  computed: {

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },

    violations() {
      return this.errors || {};
    },
    ...mapGetters('accesses', {
      Accessitems: 'list'
    }),
    accessArray: {
      get() {
        let access = [];
        for (var i = 0; i < this.item.access.length; i++) {
          if (this.item.access[i]['@id']) {
            access[i] = this.item.access[i]['@id'];
          } else {
            access[i] = this.item.access[i];
          }


        }
        return access;
      },
      set(value) { this.item.access = value; }
    }

  },
  methods: {
    ...mapActions('accesses', {
      fetchAll: 'fetchAll',
    }),
    hasAccess (access) {
      if (access) {
        for (var i = 0; i < this.item.access.length; i++) {
          if (access['@id'] == this.item.access[i]['@id']) {
            return true;
          }
        }
      }
      return false;
    },

  },
  validations: {
    item: {
      name: {
        required,
      },
    }
  }
};
</script>
